import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BetweenMenusNotification from 'bento-ordering/base/components/BetweenMenuNotification';

import {
  goToOrderSettings,
  goToMenu
} from 'bento-ordering/cart/actions/orderSettings';
import { fetchCurrentMenu } from 'bento-ordering/menus/actions';
import { updateFulfillmentOptionsForCartLocation } from 'bento-ordering/locations/actions/locationFulfillmentOptions';

class BetweenMenusNotificationContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired
  };

  handlePrimaryCta = async () => {
    await this.props.dispatch(updateFulfillmentOptionsForCartLocation());
    this.props.dispatch(goToOrderSettings());
  };

  handleSecondaryCta = async () => {
    await this.props.dispatch(updateFulfillmentOptionsForCartLocation());
    this.props.dispatch(fetchCurrentMenu());
    this.props.dispatch(goToMenu());
  };

  render() {
    return (
      <BetweenMenusNotification
        handlePrimaryCta={this.handlePrimaryCta}
        handleSecondaryCta={this.handleSecondaryCta}
        closeModal={this.props.closeModal}
      />
    );
  }
}

export default connect()(BetweenMenusNotificationContainer);
